import { ENDPOINT } from '~/constants';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { log } from '~/utils';

import { type ParsingCaseDetailResponse } from './types';
import { zodParsingCaseDetailResponseSchema } from './validations';

/**
 * Fetches a single DNPv2 parsing case with full attempt history (vadmin only).
 *
 * @param caseId - UUID of the parsing case
 * @param options - Optional request options (e.g. abort signal)
 * @returns Parsing case detail including ordered attempt history
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Parsing-Cases/operation/get_parsing_case_vadmin_parsing_cases__case_id__get
 */
export const fetchParsingCase = async (
  caseId: UUID,
  options?: KyRequestOptions,
) => {
  const response = await vestigasApi
    .get(ENDPOINT.PARSING_CASE.GET(caseId), options)
    .json<ParsingCaseDetailResponse>();

  const validated = zodParsingCaseDetailResponseSchema.safeParse(response);

  if (!validated.success) {
    log.error({
      message: 'Parsing case detail API response has validation errors',
      error: {
        caseId,
        errors: validated.error.issues,
        errorMessage: validated.error.message,
      },
    });
    return response;
  }

  return validated.data;
};
